import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { NeImageErrorIcon } from '@eastcoal/icon/NeImageErrorIcon'

import { useImageCardStore } from '../Store/hooks/useStore'
import { toPercentage } from '../utils/size'

const useStyles = createStyles(({ token }) => ({
  imageError: {
    position: 'relative',
    backgroundColor: token.colorErrorBg,
    borderRadius: token.borderRadiusXS
  },
  imgMock: {
    maxWidth: '100%'
  },
  errorTip: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: token.fontSizeSM,
    color: token.colorTextTertiary,
    textAlign: 'center'
  },
  errorText: {
    marginTop: token.paddingSM
  }
}))

export const ImageError = () => {
  const { currentWidth, ratio } = useImageCardStore(state =>
    pick(state, ['currentWidth', 'ratio'])
  )

  const imageStyle = {
    width: currentWidth,
    paddingBlockEnd: toPercentage(1 / ratio)
  }

  const { styles } = useStyles()

  return (
    <div className={styles.imageError}>
      <div className={styles.imgMock} style={imageStyle} />
      <div className={styles.errorTip}>
        <NeImageErrorIcon />
        <div className={styles.errorText}>图片上传失败</div>
      </div>
    </div>
  )
}
